module.exports = __webpack_public_path__ + "img/laboratorio2_9-16_360.d0aaa2a5.jpg";